import { RemoveReportEventConfirmationModal } from '@/components';
import { FileSourceModal } from '@/features/NewSourceModal';
import { DeleteReportConfirmationModal } from '@/features/ReportGrid/components/DeleteReportConfirmationModal';
import { EditReportModal } from '@/features/ReportGrid/components/EditReportModal';
import { type ReportEvent, type ReportWithEvents } from '@/types/report';
import { AddCustomEventModal } from './AddCustomEventModal';
import { EditReportEventModal } from './EditReportEventModal/EditReportEventModal';
import { ReportEventOrderConfirmationModal } from './ReportEventOrderConfirmationModal';

interface ReportDetailModalsProps {
    reportId: string;
    report: ReportWithEvents | undefined;
    onReportEventsChanged: () => void;
    editReportModalOpen: boolean;
    onEditReportClose: () => void;
    onEditReportSubmit: (
        name: string,
        description: string | undefined,
    ) => Promise<void>;
    deleteReportModalOpen: boolean;
    deleteReportInProgress: boolean;
    onDeleteReportConfirm: () => void;
    onDeleteReportCancel: () => void;
    removeEventModalOpen: boolean;
    removeEventInProgress: boolean;
    onRemoveEventConfirm: () => void;
    onRemoveEventCancel: () => void;
    bulkRemoveModalOpen: boolean;
    bulkRemoveCount: number;
    bulkRemoveInProgress: boolean;
    onBulkRemoveConfirm: () => void;
    onBulkRemoveCancel: () => void;
    addEventModalOpen: boolean;
    onAddEventClose: () => void;
    addSourceModalOpen: boolean;
    onAddSourceClose: () => void;
    editingEvent: ReportEvent | undefined;
    onEditEventClose: () => void;
    reorderConfirmationOpen: boolean;
    reorderInProgress: boolean;
    onReorderConfirm: () => void;
    onReorderCancel: () => void;
}

export function ReportDetailModals({
    reportId,
    report,
    onReportEventsChanged,
    editReportModalOpen,
    onEditReportClose,
    onEditReportSubmit,
    deleteReportModalOpen,
    deleteReportInProgress,
    onDeleteReportConfirm,
    onDeleteReportCancel,
    removeEventModalOpen,
    removeEventInProgress,
    onRemoveEventConfirm,
    onRemoveEventCancel,
    bulkRemoveModalOpen,
    bulkRemoveCount,
    bulkRemoveInProgress,
    onBulkRemoveConfirm,
    onBulkRemoveCancel,
    addEventModalOpen,
    onAddEventClose,
    addSourceModalOpen,
    onAddSourceClose,
    editingEvent,
    onEditEventClose,
    reorderConfirmationOpen,
    reorderInProgress,
    onReorderConfirm,
    onReorderCancel,
}: ReportDetailModalsProps) {
    return (
        <>
            {report ? (
                <EditReportModal
                    isOpen={editReportModalOpen}
                    onClose={onEditReportClose}
                    initialName={report.name}
                    initialDescription={report.description ?? ''}
                    onSubmit={onEditReportSubmit}
                />
            ) : null}
            <DeleteReportConfirmationModal
                isOpen={deleteReportModalOpen}
                deleteInProgress={deleteReportInProgress}
                onConfirm={onDeleteReportConfirm}
                onCancel={onDeleteReportCancel}
            />
            <RemoveReportEventConfirmationModal
                isOpen={removeEventModalOpen}
                removeInProgress={removeEventInProgress}
                onConfirm={onRemoveEventConfirm}
                onCancel={onRemoveEventCancel}
            />
            <RemoveReportEventConfirmationModal
                isOpen={bulkRemoveModalOpen}
                count={bulkRemoveCount}
                removeInProgress={bulkRemoveInProgress}
                onConfirm={onBulkRemoveConfirm}
                onCancel={onBulkRemoveCancel}
            />
            <ReportEventOrderConfirmationModal
                isOpen={reorderConfirmationOpen}
                isReordering={reorderInProgress}
                onConfirm={onReorderConfirm}
                onCancel={onReorderCancel}
            />
            <AddCustomEventModal
                isOpen={addEventModalOpen}
                onClose={onAddEventClose}
                reportId={reportId}
                onCreated={onReportEventsChanged}
            />
            <FileSourceModal
                isOpen={addSourceModalOpen}
                reportId={reportId}
                onClose={onAddSourceClose}
            />
            {editingEvent ? (
                <EditReportEventModal
                    isOpen={Boolean(editingEvent)}
                    onClose={onEditEventClose}
                    reportId={reportId}
                    reportEvent={editingEvent}
                    onUpdated={onReportEventsChanged}
                />
            ) : null}
        </>
    );
}
